export const renderDateColumn = (date?: Date) => {
  if (!date) return <span>-</span>;
  return <span> {new Date(date).toLocaleDateString()}</span>;
};
